export default __webpack_public_path__ + "static/media/checkbox--checked.9165e3d7.svg";